import {FormDrawer} from './FormDrawer';
import {DrawerProps} from '@mantine/core';
import {useSetupIntent} from '../hooks/useSetupIntent';
import {SetupIntent} from '../types';

export const AddFormDrawer = (props: DrawerProps) => {

    const {createRecord} = useSetupIntent();

    return (
        <FormDrawer
            record={{
                id: '',
                customerId: '',
                description: '',
                paymentMethod: '',
                usage: 'offSession',
            } as SetupIntent}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
